import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.05 12.59a.67.67 0 0 0 .613.414h6.666a.667.667 0 1 0 0-1.333H5.27l7.534-7.527a.666.666 0 0 0 0-.947.667.667 0 0 0-.947 0L4.33 10.731V5.67a.667.667 0 0 0-1.333 0v6.666q.002.131.053.254"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })